import {campaignCommentsInitialState} from '../campaignComments/campaignComments.config';
import {campaignIssuesInitialState} from '../campaignIssues/campaignIssues.slice';
import {CampaignBaseState} from './campaignBase.types';

const campaignBaseInitialState: CampaignBaseState = {
  campaignWorkflowDataByStep: null,
  mappedUsers: {},
  socialCampaignFlowStatus: null,
  isSocialCampaignPartialActive: false,
  issues: campaignIssuesInitialState,
  comments: campaignCommentsInitialState,
  connectedCampaigns: [],
  integratedServices: [],
  areIntegrationsLoading: false,
};

export {campaignBaseInitialState};
